<template>
  <v-app id="change-password-page" style="background-color: #f4f6f9;">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card class="elevation-2 pa-8 rounded-lg" dir="rtl">
              <v-card-title class="justify-center font-weight-bold">
                تغيير كلمة المرور
              </v-card-title>
              <v-card-text>
                <v-alert type="warning" text dense>
                  يجب تغيير كلمة المرور الافتراضية قبل متابعة استخدام النظام.
                </v-alert>

                <v-form @submit.prevent="submit">
                  <v-text-field
                    v-model="form.currentPassword"
                    label="كلمة المرور الحالية"
                    :type="showCurrent ? 'text' : 'password'"
                    :append-icon="showCurrent ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showCurrent = !showCurrent"
                    outlined dense
                  />

                  <v-text-field
                    v-model="form.newPassword"
                    label="كلمة المرور الجديدة"
                    :type="showNew ? 'text' : 'password'"
                    :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showNew = !showNew"
                    hint="8 أحرف على الأقل، وتشمل حرفاً كبيراً وصغيراً ورقماً ورمزاً"
                    persistent-hint
                    outlined dense
                  />

                  <v-text-field
                    v-model="form.confirmPassword"
                    label="تأكيد كلمة المرور الجديدة"
                    :type="showConfirm ? 'text' : 'password'"
                    :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showConfirm = !showConfirm"
                    outlined dense
                  />

                  <v-btn type="submit" color="primary" block large class="mt-4">
                    حفظ كلمة المرور الجديدة
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      showCurrent: false,
      showNew: false,
      showConfirm: false,
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    submit() {
      if (!this.form.currentPassword || !this.form.newPassword || !this.form.confirmPassword) {
        return;
      }

      this.$store.dispatch("security/changePassword", this.form).then(() => {
        this.$router.replace({ name: "Layout" });
      });
    },
  },
};
</script>
